import { render, staticRenderFns } from "./PinnedAnnouncement.vue?vue&type=template&id=2e4bd62c&scoped=true&lang=pug"
import script from "./PinnedAnnouncement.vue?vue&type=script&lang=js"
export * from "./PinnedAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./PinnedAnnouncement.vue?vue&type=style&index=0&id=2e4bd62c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4bd62c",
  null
  
)

export default component.exports